(function ($, window) {
    "use strict";
    DSV.template = {}; // DSV.template
})(jQuery, window);